import React from "react";
import { useIntl } from "react-intl";
import { IconHeart, IconSparkles } from "@tabler/icons-react";
import { classNames } from "@ct-react/core";
import { globalTranslations } from "../../i18n/sharable-defs";
import { DataProps } from "../../tools/components";
import { TagsData } from "../../models/article";
import "./tag-list.scss";

type TagListProps = DataProps<TagsData>;

const TagList = ({className, data }: TagListProps) => {

  const intl = useIntl();
  const wrapperClasses = classNames("tag-list", className);

  if (!data.novelty && !data.recommended && !data?.sold)
    return null;

  return (
    <ul className={wrapperClasses}>
      {data.novelty &&
        <li>
          <IconSparkles />
          {intl.formatMessage(globalTranslations.new)}
        </li>
      }
      {data.recommended &&
        <li>
          <IconHeart />
          {intl.formatMessage(globalTranslations.recommended)}
        </li>
      }
      {data.sold &&
        <li className="negative">
          {intl.formatMessage(globalTranslations.sold)}
        </li>
      }
    </ul>);

}

export default TagList;
